import { tr } from '@repo/locale';
import { type TestId } from '@repo/test-id';

import DashboardGlowingCard from '@features/ownedParkingManage/components/dashboard/DashboardGlowingCard';
import { useDashboardStatsContext } from '@features/ownedParkingManage/contexts/DashboardStatsContext';

interface Props {
  testId: TestId;
}

export default function DashboardParkingsCard({ testId }: Props) {
  const { activeParkings, totalParkings, loading } = useDashboardStatsContext();

  return (
    <DashboardGlowingCard
      title={tr('owned_parking_manage:dashboard.stats.managed_parkings')}
      counter={totalParkings}
      variant="dark"
      loading={loading}
      testId={testId}
    >
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <div className="bg-stroke-success-strong h-3 w-3 rounded-full" />
          <div className="text-sm">{tr('owned_parking_manage:dashboard.stats.active_parkings')}</div>
        </div>
        <div>
          <span className="font-semibold" data-testid={testId.append('activeParkings')}>
            {activeParkings}
          </span>
          /<span data-testid={testId.append('totalParkings')}>{totalParkings}</span>
        </div>
      </div>
    </DashboardGlowingCard>
  );
}
